<script setup>
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

import Button from 'next/button/Button.vue';
import SettingsSection from 'components/SettingsSection.vue';
import AttributesTable from './components/AttributesTable.vue';
import AddAttributeDialog from './components/AddAttributeDialog.vue';

defineProps({
  samlProvider: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const dialogRef = ref(null);

const openAddDialog = () => {
  dialogRef.value?.open();
};
</script>

<template>
  <div>
    <div class="max-w-6xl mx-auto">
      <div class="p-8">
        <div class="flex flex-col w-full gap-8">
          <SettingsSection
            :title="t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.HEADER')"
            :sub-title="t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.SUBHEADER')"
          >
            <div>
              <AttributesTable :saml-provider="samlProvider" />
            </div>

            <div class="py-8 flex w-full gap-2">
              <Button
                :label="t('WGPT_SAML.PROVIDERS.EDIT.ATTRIBUTES.ADD_ATTRIBUTE')"
                @click="openAddDialog"
              />

              <AddAttributeDialog
                ref="dialogRef"
                :saml-provider="samlProvider"
              />
            </div>
          </SettingsSection>
        </div>
      </div>
    </div>
  </div>
</template>
